import { LIVE_EVENT_CONN_STATE, LIVE_EVENT_STATE } from './live-info.interface';

export enum ErrorMessage {
  DEFAULT = '인코딩에 실패했거나 접근 제한되어 재생할 수 없습니다.',
  LIVE_DEFAULT = '해당 라이브 방송은 재생할 수 없습니다.',
  LIVE_UNAUTHORIZED = '해당 라이브 방송은 접근 제한되어 재생할 수 없습니다.',
  NO_VOD_CONTENT = '컨텐츠를 찾을 수 없습니다.',
  NO_LIVE_CONTENT = '해당 라이브 컨텐츠를 찾을 수 없습니다.',
  ENCODING_NOT_FINISHED = '동영상을 재생하기 위해 인코딩 중입니다.',
  IE_NOT_SUPPORTED = '현재 브라우저에서 지원되지 않는 기능입니다.',
  MISSING_SECURE_PARAMS = '보안 파라미터가 누락되었습니다.',
  LIVE_FINISH = '해당 라이브 방송은 종료되어 재생할 수 없습니다.',
}

export const ERRORED_STATE = {
  connState: LIVE_EVENT_CONN_STATE.FINISHED,
  state: LIVE_EVENT_STATE.DISABLED,
};
